import React from 'react';

import { PanelButton, Stack, Text } from 'shell/components';

const PanelButtonDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>PanelButton</Text>
            <PanelButton selected onClick={console.log}>
                <Stack alignItems={'flex-start'}>
                    <Text variant={'h6'}>Course 101</Text>
                    <Text color={'light'} variant={'p2'}>
                        Fall 2022
                    </Text>
                </Stack>
            </PanelButton>
            <PanelButton onClick={console.log}>
                <Stack alignItems={'flex-start'}>
                    <Text variant={'h6'}>Course 101</Text>
                    <Text color={'light'} variant={'p2'}>
                        Spring 2023
                    </Text>
                </Stack>
            </PanelButton>
        </>
    );
};

export default PanelButtonDemo;
